<template>
  <nav aria-label="pagination" role="pagination">
    <ul
      class="pagination"
      :class="[alignment]"
    >
      <li
        class="page-item previous"
        :class="{ disabled: currentPage === 1 }"
        aria-label="Goto previous page"
      ><router-link class="page-link" :to="linkGen(currentPage - 1)">‹</router-link></li>

      <li class="page-item disabled"><span class="page-link">{{ currentPage }} / {{ totalPages }}</span></li>

      <li
        class="page-item next"
        :class="{ disabled: currentPage === totalPages }"
        aria-label="Goto next page"
      ><router-link class="page-link" :to="linkGen(currentPage + 1)">›</router-link></li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
      validator(value) {
        return Number.isInteger(value) && value >= 1
      }
    },
    totalPages: {
      type: Number,
      default: 1
    },
    linkGen: {
      type: Function,
      default: (page) => {
        return { path: page.toString() }
      }
    },
    align: {
      type: String,
      default: 'center'
    }
  },

  computed: {
    alignment() {
      return `justify-content-${this.align}`
    }
  }
}
</script>
